import React from "react";

export default ({
                    disabled = false,
                    ...props
                }) =>
    <div className="btn-group" role="group">
        <a href="/" className="btn btn-secondary btn-bluecolor" {...props} disabled={disabled}>TILBAKE</a>
    </div>;
